export enum GlobalMutationTypes {
  SET_LOADING = "SET_LOADING",
  SET_LOGIN_DATA = "SET_LOGIN_DATA",
  SET_LOGIN_TOKEN = "SET_LOGIN_TOKEN",
  SET_LOGIN_TYPE = "SET_LOGIN_TYPE",
  SET_USER_TYPE = "SET_USER_TYPE",
  LOGOUT = "LOGOUT",
}
